import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-percent-pie',
  templateUrl: './percent-pie.component.html',
  styleUrls: ['./percent-pie.component.sass']
})
export class PercentPieComponent implements OnInit {
  @Input() percent = 0;

  constructor() { }

  ngOnInit() {
  }

}
